module.exports = __webpack_public_path__ + "static/img/steps_3.f702023.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/kfc/steps_3.png
// module id = 2t/v
// module chunks = 0